import { IReminder } from '@alberta/konexi-shared';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

export function getReminderForm(formBuilder: UntypedFormBuilder, reminder?: IReminder): UntypedFormGroup {
  return formBuilder.group({
    date: [reminder?.date],
    annotation: [reminder?.annotation],
  });
}
